
import TokenBalance from '@/components/TokenBalance.vue'
import { bootstrap, shutdown, EventCallback, onAccountAvailable }from '@stakeordie/griptape.js'

export default {
  name: 'Wallet',
  components: {
    TokenBalance
  },
  setup(){
    return{
      bootstrap
    }
  }
}
